export const BERA_LIST_PATH = '/custom-reports/bera';
export const BERA_REPORT_PATH = '/custom-reports/bera/report';
export const BERA_VERSION_V2 = 2;
export const FIRST_PAGE = 1;
export const FIRST_VERSION_INDEX = 0;
export const DEFAULT_PAGE_SIZE = 10;
export const TLID_PAGE_SIZE = 15;
export const ACTION_ICON_SIZE = 24;
export const WARNING_ICON_SIZE = 24;
export const MODAL_CLOSE_ICON_SIZE = 16;
export const MODAL_SMALL_WIDTH = 610;
export const MODAL_LARGE_WIDTH = 957;
export const MODAL_CONFIRM_WIDTH = 400;
export const CONFIRM_ICON_SIZE = 64;
export const EMPTY_VALUE = '-';
export const VERSION_SPAN = 5;
export const TLID_SPAN = 12;
export const DATE_SPAN = 4;
export const ACTIONS_SPAN = 3;
export const FILTER_PANEL_KEY = '1';
export const FILTER_PANEL_CLOSED_KEY = '0';
export const ACTIONS_GUTTER = 16;

export const EMPTY_FILTER_FIELDS = {
	company_id_filter: undefined,
	sector_id: undefined,
	line_id: undefined,
	workstation_id: undefined,
	cycle_id: undefined,
	task_id: undefined,
	report_name: undefined,
	created_at: undefined,
	updated_at: undefined,
	type_overall_score: undefined,
	min_overall_score: undefined,
	max_overall_score: undefined,
	type_rpn: undefined,
	min_rpn: undefined,
	max_rpn: undefined
};

export const COMPARISON_TYPE = {
	GREATER: 'gt',
	GREATER_OR_EQUAL: 'gte',
	LESS: 'lt',
	LESS_OR_EQUAL: 'lte',
	BETWEEN: 'between'
} as const;
